// extracted by mini-css-extract-plugin
export default {"container":"footer_container__SMkK6","wrapper":"footer_wrapper__m9Ekf","item":"footer_item__FV-OM"};